import type { Group, PredictionCategory } from "@/schemas";

const createGroupSlug = (name: string) => {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};

const isGroupAccessRequired = (group: Group | null | undefined): boolean => {
  if (!group) return false;

  return (
    group.group_visibility === "members_only" ||
    (group.group_visibility === "everyone" && group.locked)
  );
};

const findCategoryByEventName = (
  categories: PredictionCategory[],
  eventName: string,
) => {
  const normalizedEventName = eventName.toLowerCase();
  const matchedCategory = categories.find(
    (category) => category.name.toLowerCase() === normalizedEventName,
  );
  const subcategory = matchedCategory?.subcategories.find(
    (subCategory) => subCategory.default,
  );

  return {
    category: matchedCategory?.name,
    subCategory: subcategory?.name,
  };
};

export { createGroupSlug, isGroupAccessRequired, findCategoryByEventName };
